import styled from 'styled-components';

import { BreakPoint } from '@makemydeal/dr-activities-common';
import { MAX_APP_CONTAINER_WIDTH_NEW, FULL_SCREEN_SLIDE_OUT_WIDTH } from '@makemydeal/dr-shared-ui-utils';

export const StyledChangeVehicleActivity = styled.div`
    .change-vehicle-container {
        max-width: 1360px;
        position: relative;
        top: 40px;
        margin: auto;
        margin-bottom: 45px;
        padding: 0 1rem;
        padding-bottom: 90px;

        @media (max-width: ${BreakPoint.MEDIUM}) {
            width: 100%;
            padding: 0px 16px 90px;
        }

        .change-vehicle-footer {
            background: ${({ theme }) => theme.tokens.BaseColorWhite};
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
        }

        .change-vehicle-footer--slideout {
            left: calc(100vw - ${FULL_SCREEN_SLIDE_OUT_WIDTH});
        }

        .change-vehicle-footer-button-container {
            max-width: ${MAX_APP_CONTAINER_WIDTH_NEW};
            margin: 0 auto;
        }

        .change-vehicle-footer--slideout .change-vehicle-footer-button-container {
            max-width: 100%;
        }
    }

    .change-vehicle-container--slideout {
        max-width: 100%;
        top: 20px;
        padding: 0;
    }
`;
